import axios from "axios";

//export const LOGIN_URL = "api/auth/login";
// const urlBase =  "https://api.itpscorp.com/crmui";
const json = require("../../config.json");
const urlBase = json.urlBase;
// const urlBase =  "http://api.itpscorp.com/dev/crmui"; 

// export const LOGIN_URL = "http://api.itpscorp.com/dev/crmui/auth/login";
export const LOGIN_URL = urlBase + "/auth/login";

export const REGISTER_URL = "api/auth/register";
export const REQUEST_PASSWORD_URL = urlBase + "/auth/reset-password?email={{username}}";

// Two-factor authentication endpoints.
export const TWOFA_SETUP_URL = urlBase + "/auth/2fa/setup";
export const TWOFA_CONFIRM_URL = urlBase + "/auth/2fa/confirm";
export const TWOFA_VERIFY_URL = urlBase + "/auth/2fa/verify";

// Dedicated axios instance for the 2FA exchange. The global axios instance has
// a response interceptor that force-redirects to /auth/login on ANY 401, which
// would destroy the in-progress 2FA flow whenever a user mistypes a code. This
// instance has no interceptors, so callers receive 401s normally. The
// short-lived MFA-pending token is passed explicitly per request and never
// persisted.
const authClient = axios.create();

export function setup2FA(tempToken) {
  return authClient.post(TWOFA_SETUP_URL, {}, {
    headers: { Authorization: "Bearer " + tempToken },
  });
}

export function confirm2FA(tempToken, code) {
  return authClient.post(TWOFA_CONFIRM_URL, { code }, {
    headers: { Authorization: "Bearer " + tempToken },
  });
}

export function verify2FA(tempToken, code) {
  return authClient.post(TWOFA_VERIFY_URL, { code }, {
    headers: { Authorization: "Bearer " + tempToken },
  });
}

// Self-service authenticator replacement (logged-in users, from the profile
// page). Uses the clean instance so a wrong password / bad code returns a 401
// to the caller instead of triggering the global logout redirect. The session
// token is attached explicitly from stored userDetails.
export const TWOFA_REPLACE_SETUP_URL = urlBase + "/profile/2fa/replace/setup";
export const TWOFA_REPLACE_CONFIRM_URL = urlBase + "/profile/2fa/replace/confirm";

function sessionAuthHeader() {
  try {
    const details = JSON.parse(localStorage.getItem("userDetails") || "{}");
    const token = (details.access_token || "").replace(/['"]/g, "");
    return token ? { Authorization: "Bearer " + token } : {};
  } catch (e) {
    return {};
  }
}

export function replace2FASetup(password) {
  return authClient.post(TWOFA_REPLACE_SETUP_URL, { password }, { headers: sessionAuthHeader() });
}

export function replace2FAConfirm(code) {
  return authClient.post(TWOFA_REPLACE_CONFIRM_URL, { code }, { headers: sessionAuthHeader() });
}


export const ME_URL = "../";
//export const ME_URL = "../home/Dashboard";

export function login(email, pass) {

  return axios.post(LOGIN_URL,{
      username: email,
      password: pass
    })
}
// export function login(email, password) {
//     return axios.post(LOGIN_URL, { email,password });

// }
  //return axios.post(LOGIN_URL, { email,password });
  // alert("por aqui paso");

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  console.log("zzzzzzzzzzzzzzz");
  return axios.get(urlBase +"/auth/reset-password?email="+email, { email });
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get(ME_URL);
}

export function initiateGoogleSSO() {
  const redirectUrl = window.location.origin + "/auth/login";
  window.location.href =
    urlBase +
    "/auth/google/login?redirect_url=" +
    encodeURIComponent(redirectUrl);
}
